module.exports = __webpack_public_path__ + "assets/img/calculator.7bf59101.svg";